"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tokens = _interopRequireDefault(require("../tokens"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MuiAvatar = function MuiAvatar() {
  return {
    root: {
      width: 32,
      height: 32,
      '&$rounded': {
        borderRadius: _tokens["default"].radii.semiRounded
      }
    }
  };
};

var _default = MuiAvatar;
exports["default"] = _default;